export default __webpack_public_path__ + "images/card-logo-visa.644851fa6162d3c07b56b33275740e83.png";